import { render, staticRenderFns } from "./PositionCell.vue?vue&type=template&id=65a9578b&"
import script from "./PositionCell.vue?vue&type=script&lang=ts&"
export * from "./PositionCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports